const backendClassNames = {
    'Job': 'Orgavision.Rewind365.JobManagement.Job',
    'JobTask': 'Orgavision.Rewind365.JobManagement.JobTask'
};

export default backendClassNames;